import type FeaturesState from '@modules/store/common/types/FeaturesState.entity';

export const state: FeaturesState = {
  loading: null,
  features: {},
};
